// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"a9347f23","151":"57c5ea92","373":"21b1a3d2","417":"04e96d63","453":"447603d4","724":"3da4ba68","752":"7594c87e","786":"bb753352","831":"c73dde4b","874":"6d4e5a30"}[chunkId] + ".chunk.js";
};